export const type = 'listed';
